import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import {  catchError, map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { localStorageService } from './local-storage.service';
import { AuthService } from './auth.service';
import {   retry } from 'rxjs/operators';
import { ScrollbarHelper } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';

interface ApiResponse {
  data: any;  // Define the type of 'data' based on your API response structure, e.g., `any[]` or a specific shape.
}

@Injectable({
  providedIn: 'root'
})

export class ApisService {
  apiUrl: string;

 
  
  // domain
  private domain = environment.productionDomain;

  
  DepartmentsAdd: any[] = [];
  password: any[] = [];
  email: any[] = [];


  constructor(private http: HttpClient,private router: Router, private authService: AuthService,
    private localStorage: localStorageService,private translate: TranslateService
  ) {}


  /*----------  Creating Header   ----------*/
createHeaders(): HttpHeaders {
  const token = localStorage.getItem("token") || "default_token";
  return new HttpHeaders({
    Accept: "application/json",
    "Accept-Language": "en",
    Authorization: `Bearer ${token}`,
  });
}

  private request(
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
    endpoint: string,
    data?: any,
    params?: HttpParams
  ): Observable<any> {
    let headers = this.createHeaders();
    if (data instanceof FormData) headers = headers.delete("Content-Type");

    return this.http
      .request(method, `${this.domain}${endpoint}`, {
        body: ["POST", "PUT", "PATCH"].includes(method) ? data : null,
        headers,
        params: params || new HttpParams(),
      })
      .pipe(
        tap((response) => console.log(`[${method}] ${endpoint} =>`, response)),
        catchError(this.handleError.bind(this))
      );
  }


/*=============================================
=            CALLING Methods            =
=============================================*/
  get(endpoint: string, params?: HttpParams): Observable<any> {
    return this.request("GET", endpoint, null, params);
  }

  post(endpoint: string, data: any , params?: HttpParams): Observable<any> {
    return this.request("POST", endpoint, data , params);
  }

  put(endpoint: string, data: any): Observable<any> {
    return this.request("PUT", endpoint, data);
  }

  patch(endpoint: string, data: any): Observable<any> {
    return this.request("PATCH", endpoint, data);
  }

  delete(endpoint: string): Observable<any> {
    return this.request("DELETE", endpoint);
  }


/*=====  End of Fetching Methods  ======*/


/*----------  Error Handling  ----------*/
  //   private handleError(error: HttpErrorResponse): Observable<never> {
  //   console.error("API Error:", error);
  //   if (error.status === 401 || error.error?.message === "Unauthenticated.") {
  //     this.router.navigate(["pages/authentication/login-v2"]);
  //   }
  //   return throwError(error);
  // }




  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.status === 401) {
      const deviceId = this.authService.getCurrentDevice()?.id;
      this.authService.logout(deviceId);
      this.localStorage.clear();
      this.router.navigate(['/auth/login']); 
    }
    return throwError(error);
  }

  company() {
    return this.http.post(this.domain + '/dashboard/companies',{});
  }
 

  requestAds():Observable<any> { 
    return this.http.post<any>(this.domain +'user-sliders',{});
  }
  
  // levels(): Observable<any> {
  //   return this.authenticatedGet(
  //     `${this.domain}/api/dashboard-auth-api/levels`
  //   );
  // }

  // article() {
  //   return this.http.post(this.domain + '/articles',{});
  // }
 
  article(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'articles', {});
  }
  
 
  about(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'about-app', {});
  }
 
  getCountry(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'countries', {});
  }
 
  LoginOtp(data: any, token: any): Observable<any> {
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(`${this.domain}user/active-profile`, data, { headers: header });
  }
  completeProfile(token: any, data: any) {
    return this.http.post(`${this.domain}user/update-profile`, data, { headers: new HttpHeaders().set('Authorization', `Bearer ${token}`) });
  }
  countries(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'countries', {});
  }
 
  ganatakCommunity(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'community-posts', {});
  }

  plantCards(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'user/make-order', {});
  }
  
 
  store(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'active-store-products', {});
  }
  // users(): Observable<any> {
  //   return this.http.get<any>(this.domain + 'api/admin/user', {});
  // }
  onBoarding(): Observable<any> {
    return this.http.get<any>(this.domain + 'api/onboarding', {});
  }

users(): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.get<any>(
    this.domain + 'api/admin/user',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}



analasys(): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.get<any>(
    this.domain + 'api/admin/dashboard',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}




usersDetails(id: any): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.get<any>(
    `${this.domain}api/admin/user/${id}`, 
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}


  getArticlesDetailss(id : any):Observable<any> {
  return this.http.get(`/dashboard-auth-api/articles/${id}`);
}

notifications(): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.get<any>(
    this.domain + 'api/admin/notifications',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}

categories(): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.get<any>(
    this.domain + 'api/adhkar/categories',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}

todayUsers(): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.get<any>(
    this.domain + 'api/admin/today-users',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}

fiqh(): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.get<any>(
    this.domain + 'api/admin/fiqh/topics',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}

lessons(): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.get<any>(
    this.domain + 'api/admin/fiqh/lessons',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}

questions(): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.get<any>(
    this.domain + 'api/fatwa-questions',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}
answer(id: any, payload: any): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.post<any>(
    this.domain + `api/admin/fatwa-questions/${id}/answer`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}

fatwas(): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.get<any>(
    this.domain + 'api/fatwas',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}

items(): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.get<any>(
    this.domain + 'api/adhkar/items',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}

privacyPolicy(): Observable<any> {
  const token = localStorage.getItem('token');

  return this.http.get<any>(
    this.domain + 'api/privacy-policies',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
}

Deletenotifications(id:any): Observable<any> { 
  const token = localStorage.getItem('token');
  // const lang = this.translate.currentLang;

  // const headers = new HttpHeaders({
  //   'Authorization': `Bearer ${token}`,
  //   'Accept-Language': lang
  // });

  return this.http.delete<any>(
    `${this.domain}api/admin/notifications/${id}`,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}
  

DeleteItems(id:any): Observable<any> { 
  const token = localStorage.getItem('token');
  // const lang = this.translate.currentLang;

  // const headers = new HttpHeaders({
  //   'Authorization': `Bearer ${token}`,
  //   'Accept-Language': lang
  // });

  return this.http.delete<any>(
    `${this.domain}api/adhkar/items/${id}`,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}
  

DeleteCategories(id:any): Observable<any> { 
  const token = localStorage.getItem('token');
  // const lang = this.translate.currentLang;

  // const headers = new HttpHeaders({
  //   'Authorization': `Bearer ${token}`,
  //   'Accept-Language': lang
  // });

  return this.http.delete<any>(
    `${this.domain}api/adhkar/categories/${id}`,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}
  

DeleteUsers(id:any): Observable<any> { 
  const token = localStorage.getItem('token');
  // const lang = this.translate.currentLang;

  // const headers = new HttpHeaders({
  //   'Authorization': `Bearer ${token}`,
  //   'Accept-Language': lang
  // });

  return this.http.delete<any>(
    `${this.domain}api/admin/user/${id}`,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}
  

DeleteLessons(id:any): Observable<any> { 
  const token = localStorage.getItem('token');
  // const lang = this.translate.currentLang;

  // const headers = new HttpHeaders({
  //   'Authorization': `Bearer ${token}`,
  //   'Accept-Language': lang
  // });

  return this.http.delete<any>(
    `${this.domain}api/admin/fiqh/lessons/${id}`,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}
  

DeleteTopics(id:any): Observable<any> { 
  const token = localStorage.getItem('token');
  // const lang = this.translate.currentLang;

  // const headers = new HttpHeaders({
  //   'Authorization': `Bearer ${token}`,
  //   'Accept-Language': lang
  // });

  return this.http.delete<any>(
    `${this.domain}api/admin/fiqh/topics/${id}`,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}
  

Deletefatwas(id:any): Observable<any> { 
  const token = localStorage.getItem('token');
  // const lang = this.translate.currentLang;

  // const headers = new HttpHeaders({
  //   'Authorization': `Bearer ${token}`,
  //   'Accept-Language': lang
  // });

  return this.http.delete<any>(
    `${this.domain}api/admin/fatwas/${id}`,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}
  

DeleteFatwaQuestions(id:any): Observable<any> { 
  const token = localStorage.getItem('token');
  // const lang = this.translate.currentLang;

  // const headers = new HttpHeaders({
  //   'Authorization': `Bearer ${token}`,
  //   'Accept-Language': lang
  // });

  return this.http.delete<any>(
    `${this.domain}api/admin/fatwa-questions/${id}`,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}
  

DeleteOnBoarding(id:any): Observable<any> { 
  const token = localStorage.getItem('token');
  // const lang = this.translate.currentLang;

  // const headers = new HttpHeaders({
  //   'Authorization': `Bearer ${token}`,
  //   'Accept-Language': lang
  // });

  return this.http.delete<any>(
    `${this.domain}api/onboarding/${id}`,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}
  
  

DeleteSocialLinks(id:any): Observable<any> { 
  const token = localStorage.getItem('token');
  // const lang = this.translate.currentLang;

  // const headers = new HttpHeaders({
  //   'Authorization': `Bearer ${token}`,
  //   'Accept-Language': lang
  // });

  return this.http.delete<any>(
    `${this.domain}api/social-links/${id}`,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  ).pipe(
    catchError(this.handleError.bind(this))
  );
}
  


 addnotifications(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + 'api/admin/notifications',payload,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}

  


 addCategories(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + 'api/adhkar/categories',payload,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}

  

 addUsers(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + 'api/admin/user',payload,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}

  


 addfatwaquestions(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + 'api/fatwa-questions',payload,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}

  


 addfatwa(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + 'api/admin/fatwas',payload,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}

  


 addfiqhTopic(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + 'api/admin/fiqh/topics',payload,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}

  
  


 addfiqhLessons(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + 'api/admin/fiqh/lessons',payload,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}

  


 addItems(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + 'api/adhkar/items',payload,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}



 addSocialLinks(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + 'api/social-links',payload,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}



 addOnBoarding(payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    this.domain + 'api/onboarding',payload,
    {     headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}



editnotifications(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}api/admin/notifications/${id}`,
    payload,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}



editCategories(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}api/adhkar/categories/${id}`,
    payload,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}



editUsers(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}api/admin/user/${id}`,
    payload,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}

editfatwaquestions(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}api/admin/fatwa-questions/${id}`,
    payload,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}



editItems(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.put<ApiResponse>(
    `${this.domain}api/adhkar/items/${id}`,
    payload,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}



editPrivacyPolicy(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    `${this.domain}api/admin/privacy-policies/${id}`,
    payload,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}




editSocialLinks(id: string, payload: any): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.post<ApiResponse>(
    `${this.domain}api/social-links/${id}`,
    payload,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}





getnotifications(id: string): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.get<ApiResponse>(
    `${this.domain}api/admin/notifications/${id}`,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}



getItems(id: string): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.get<ApiResponse>(
    `${this.domain}api/adhkar/items/${id}`,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}



getCategories(id: string): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.get<ApiResponse>(
    `${this.domain}api/adhkar/categories/${id}`,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}



getUsers(id: string): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.get<ApiResponse>(
    `${this.domain}api/admin/user/${id}`,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}


getfatwaQuestions(id: string): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.get<ApiResponse>(
    `${this.domain}api/fatwa-questions/${id}`,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}


getSocialLinks(id: string): Observable<ApiResponse> {
  const token = localStorage.getItem('token');

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en'
  });

  return this.http.get<ApiResponse>(
    `${this.domain}api/social-links/${id}`,
    {    headers: {
        Authorization: `Bearer ${token}`
      } }
  );
}

  socialLinks(): Observable<any> {
    return this.http.get<any>(this.domain + 'api/social-links', {});
  }





  companies(service_id: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + 'service-companies', {service_id: service_id});
  }
  //Consulting List
  requestConsultations() : Observable<ApiResponse> {
    //waiting for the token
    // const Authorization = '1myQSGIIuD22gI3iruJXWOILoysWAOtF02y1P7XX' 
    // const httpheaders :HttpHeaders = new HttpHeaders ().set(
    //   'Authorization' , `Bearer ${Authorization}`
    // )
    return this.http.post<ApiResponse>(this.domain+ 'user/user-consultants', {} )
  }
 //edit consultation
  requestConsultationDetail(consulting_id : any): Observable<ApiResponse>{ 
    return this.http.post<ApiResponse>(this.domain+ 'user/make-consultant' ,{consulting_id:consulting_id} )
  }
  //make consultation
  requestConsultationBook() : Observable<ApiResponse> {  
    const headers = HttpHeaders
    return this.http.post<ApiResponse>(this.domain+'user/consultant-details',{})
  }
  
  requestTerms(): Observable<ApiResponse> { 
    return this.http.post<ApiResponse>(this.domain+'terms-app' , {})
  }

  requestTagArticles(tag_id :any) : Observable<ApiResponse> { 
    //authorization needed
    
    return this.http.post<ApiResponse>(this.domain+'tag-articles',{tag_id:tag_id})
  }

  requestTagProducts(tag_id:any):Observable<ApiResponse>{
    //authorization needed 
    return this.http.post<ApiResponse>(this.domain+'tag-products',{tag_id:tag_id})
  }

  requestNotificationsCount():Observable<ApiResponse>{
    //authorization needed 
    return this.http.post<ApiResponse>(this.domain+'user-notifications-count',{})
  }

  requestNotifications(page:any):Observable<ApiResponse>{
    //authorization needed  
    return this.http.post<ApiResponse>(this.domain+'user-notifications',{page:page})
  }

  requestNotificationSee(notification_id:any):Observable<ApiResponse>{
    //authorization needed  
    return this.http.post<ApiResponse>(this.domain+'user-seen-notifications',{notification_id:notification_id})
  }

  requestServiceCategories():Observable<ApiResponse> { 
    return this.http.post<ApiResponse>(this.domain+'services' ,{})

  }

  requestServiceSubCategories():Observable<ApiResponse>{ 
    return this.http.post<ApiResponse>(this.domain+'sub-services',{})
  }

  requestOffers(page:number , category_id:string , discount_sort:string ,keyword:string):Observable<ApiResponse>{ 
    return this.http.post<ApiResponse>(this.domain+'search-offers',
      {page:page , category_id:category_id , discount_sort:discount_sort , keyword:keyword})
  }
requestHomeOffers():Observable<ApiResponse>{
  return this.http.post<ApiResponse>(this.domain+'home-products',{})
}

requestCategoryOffers(category_id:number):Observable<ApiResponse>{
  return this.http.post<ApiResponse>(this.domain+'category-offer',{category_id:category_id})
}

requestCancelReasons():Observable<ApiResponse>{ 
  return this.http.post<ApiResponse>(this.domain+'user/cancelOrderReasons',{})
}
requestCancelOrder(order_id:number , cancellation_reason_id:number ):Observable<ApiResponse>{
  return this.http.post<ApiResponse>(this.domain+'user/cancelOrder', 
    {order_id:order_id , cancellation_reason_id:cancellation_reason_id})
}
requestMarketCategories():Observable<ApiResponse>{ 
  return this.http.post<ApiResponse>(this.domain+'categories-list',{})
}

requestShops():Observable<ApiResponse>{ 
  return this.http.post<ApiResponse>(this.domain+'category-stores',{})
}
requestShopProductsCategories(shop_id:number):Observable<ApiResponse>{
  return this.http.post<ApiResponse>(this.domain+'store-id-categories',{shop_id:shop_id})
}

requestShopProducts():Observable<ApiResponse>{ 
  return this.http.post<ApiResponse>(this.domain+'store-category-id-products',{})
}
requestProducts():Observable<ApiResponse>{ 
  return this.http.post<ApiResponse>(this.domain+'category-store-id-products',{})
}
requestArticleCategories():Observable<ApiResponse>{ 
  return this.http.post<ApiResponse>(this.domain+'articles-categories-list' ,{})
}






  // companyRate(companyId: any): Observable<any> {
  //   return this.http.post(`${this.domain}/dashboard/company-rates`, { companyId: companyId });
  // }

 
  // Login(email: any, password: any) {
  //       const headers = new HttpHeaders().set('Content-Type', 'application/json');

  //   return this.http.post('https://qaiim.newegyptgroup.com/api/dashboard/admin-login', { email, password }, {headers});
  // }
 

  // removeDepartment(departmentId: any): Observable<any> {
  //   return this.http.post(`${this.domain}/dashboard/remove-department`,{departmentId});
  // }
  

  getLogin(data:any): Observable<any> {
    const url = `${this.domain}user/login`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http
      .post(url, data, { headers })
      .pipe(catchError(this.handleError));
  }

  getArticlesDetails(id : any):Observable<any> {
  return this.http.get(`/dashboard-auth-api/articles/${id}`);
}
} 




